import {
  svgPathStyle,
  svgStyle
} from 'components/display/ValidationIconStyles';
import React from 'react';

function SuccessCheckmark({ overrideSvgStyle }) {
  return (
    <svg
      css={overrideSvgStyle || svgStyle}
      preserveAspectRatio='xMidYMin'
      title='Success'
      viewBox='0 0 52 52'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        css={svgPathStyle}
        d='M14.1 27.2l7.1 7.2 16.7-16.8'
        fill='none'
        stroke='#40bf9f'
      />
    </svg>
  );
}

export default SuccessCheckmark;
